import { useState } from "react";
import { BackArrow, ServiceIcon, SaveIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  IconWrapper,
  InputField,
  ListCard,
  PreviewCard,
  PrimaryHeading,
  RightMainContainer,
  SecondaryHeading,
  ListIconWrapper,
  AddComponent,
  MainButton,
  DeleteButton,
} from "commonUI";
import { useParams } from "react-router-dom";
import { ModulePrefixes } from "enums";

export default function AddEditProposalTemplate() {
  const { id } = useParams();
  const [serviceList, setServiceList] = useState([
    "[Service Title]",
    "[Service Title]",
    "[Service Title]",
    "[Service Title]",
  ]);

  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <IconWrapper>
            <BackArrow />
            <PrimaryHeading>[Proposal Title]</PrimaryHeading>
          </IconWrapper>
          <div className="flex items-center justify-center gap-14">
            <DeleteButton
            show={id !== "add"}
            deleteMessage="You are about to delete Content Request Item from your account. This
            action cannot be undone! All settings related to the WP Site
            Launcher Content Request Item will permanently removed. Do you wish to
            proceed and delete the Content Request Item?"
            />
            <MainButton>
              <SaveIcon />
              Save Changes
            </MainButton>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <InputField label="Title" placeholder="Write Title Here" />
          <div className="mt-2">
            {serviceList.map((item, index) => {
              return (
                <ListCard
                  key={index}
                  data={item}
                  secondaryData="Price"
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/services/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setServiceList(() => [...serviceList, `Copy of ${data}`]);
                  }}
                  deleteIcon={true}
                  icon={
                    <ListIconWrapper>
                      <ServiceIcon />
                    </ListIconWrapper>
                  }
                />
              );
            })}
          </div>
          <AddComponent title={"Add Service"} className="mt-3 mb-3" />
          <div className="mt-2">
            <SecondaryHeading>Tags</SecondaryHeading>
            <div className="flex items-center gap-5">
              <PreviewCard
                color="#F12424"
                title="Tag 1"
                icon={true}
                className="m-0"
              />
              <PreviewCard
                color="#7846FF"
                title="Tag 2"
                icon={true}
                className="m-0"
              />
              <PreviewCard
                color="#2EA3F2"
                title="Tag 3"
                icon={true}
                className="m-0"
              />
            </div>
          </div>
          <AddComponent />
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
